import React from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import DashboardComponent from "../Components/Dashboard/DashboardComponent";
import CreateReport from "../Components/CreateReport/CreateReport";

const useStyles = makeStyles((theme) =>
  createStyles({
    dashboardViewContainer: {
      position: "absolute",
      left: "0",
      right: "0",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
  })
);

const DashboardView = ({ createReportOpen, setCreateReportOpen, savedReport, setSavedReport, match, googleScriptLoaded, userId }) => {
  const classes = useStyles();
  const user = match?.params?.user;

  return (
    <div className={classes.dashboardViewContainer}>
      {createReportOpen.open && (
        <CreateReport
          user={user}
          googleScriptLoaded={googleScriptLoaded}
          createReportOpen={createReportOpen}
          setCreateReportOpen={(status) => setCreateReportOpen(status)}
          setSavedReport={(status) => setSavedReport(status)}
        />
      )}
      <DashboardComponent
        createReportOpen={createReportOpen}
        userId={userId}
        user={user}
        setCreateReportOpen={(status) => setCreateReportOpen(status)}
        setSavedReport={(status) => setSavedReport(status)}
        savedReport={savedReport}
      />
    </div>
  );
};

DashboardView.propTypes = {
  savedReport: PropTypes.bool,
  setSavedReport: PropTypes.func,
  createReportOpen: PropTypes.object,
  setCreateReportOpen: PropTypes.func,
  match: PropTypes.object,
  googleScriptLoaded: PropTypes.bool,
  userId: PropTypes.number,
};

export default DashboardView;
